exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-pick-your-playground-tsx": () => import("./../../../src/templates/PickYourPlayground.tsx" /* webpackChunkName: "component---src-templates-pick-your-playground-tsx" */)
}

